// extracted by mini-css-extract-plugin
export default {"login_form":"ForgotPasswordPage_login_form__5a1EB","note":"ForgotPasswordPage_note__oQtgm"};